import { makeStyles, Typography } from "@material-ui/core";
import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
const useStyles = makeStyles((theme) => ({
    root: ({ signal, variant }) => ({
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        paddingTop: theme.spacing(1.25),
        paddingRight: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        backgroundColor: variant === "primary" && !signal ? "#FEE9EE" : "#FFFFFF",
        borderColor: variant === "primary" && !signal ? "#FA255E" : "#FEC8D7",
        borderRadius: 16,
        borderStyle: "solid",
        borderWidth: 2,
        gap: "4px"
    }),
    paragraph: {
        fontWeight: 500,
        fontSize: 16,
        lineHeight: "24px"
    },
    h3: {
        marginBottom: ".25em"
    },
    fontWeightMedium: {
        fontWeight: 600
    }
}));
export const Badge = ({ variant, title, text, usp }) => {
    const [signal, setSignal] = useState(false);
    const classes = useStyles({ variant, signal });
    useEffect(() => {
        if (variant === "primary") {
            setSignal(true);
        }
    }, [variant]);
    return (React.createElement(motion.div, { className: classes.root, variants: {
            pulse: {
                scale: [1, 1.1, 1],
                transition: {
                    duration: 0.2
                }
            }
        }, animate: signal ? "pulse" : null, onAnimationComplete: () => setSignal(false) },
        React.createElement(Typography, { variant: "h4", color: "primary" }, title),
        React.createElement(Typography, { variant: "h4", color: "textPrimary", className: classes.fontWeightMedium }, text),
        React.createElement(Typography, { variant: "h5", color: "textPrimary", className: classes.fontWeightMedium }, usp)));
};
//# sourceMappingURL=Badge.js.map